import { messaging, getToken } from "./firebase";

const VAPID_KEY = "BILRjeYF7GfRpoJ8_KtP-O9K7Wz4IYKsCGTFUXH9dBDglZTSSsv113QmV2ClVvZHUZMAN7LpeoXtbsGVbxb6n1E";

export const getFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      return token;
    } else {
      console.warn("Notification permission not granted");
      return null;
    }
  } catch (err) {
    console.error("FCM token error:", err);
    return null;
  }
};
